type DateInput = string | Date

export function toDate(input: DateInput): Date {
  return typeof input === 'string' ? new Date(input) : input
}

export function formatDate(
  date: Date,
  options: Intl.DateTimeFormatOptions,
  locale = 'en',
): string {
  return new Intl.DateTimeFormat(locale, options).format(date)
}

export function toYMD(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

export function addDays(date: Date, days: number): Date {
  const r = new Date(date)
  r.setDate(r.getDate() + days)
  return r
}

export function addWeeks(date: Date, weeks: number): Date {
  return addDays(date, weeks * 7)
}

export function addMonths(date: Date, months: number): Date {
  const r = new Date(date)
  r.setMonth(r.getMonth() + months)
  return r
}

export function startOfDay(date: Date): Date {
  const r = new Date(date)
  r.setHours(0, 0, 0, 0)
  return r
}

// ISO 8601 week: starts on Monday
export function startOfWeek(date: Date): Date {
  const r = startOfDay(date)
  const day = r.getDay()
  r.setDate(r.getDate() - (day === 0 ? 6 : day - 1))
  return r
}

export function startOfMonth(date: Date): Date {
  const r = new Date(date)
  r.setDate(1)
  r.setHours(0, 0, 0, 0)
  return r
}

export function diffDays(a: Date, b: Date): number {
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())
  return Math.floor((utc1 - utc2) / 86_400_000)
}

export function diffWeeks(a: Date, b: Date): number {
  return Math.floor(diffDays(a, b) / 7)
}

export function diffMonths(a: Date, b: Date): number {
  return (
    (a.getFullYear() - b.getFullYear()) * 12 + (a.getMonth() - b.getMonth())
  )
}

export function isBetween(date: Date, start: Date, end: Date): boolean {
  const t = date.getTime()
  return t >= start.getTime() && t <= end.getTime()
}

export function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  )
}

export function isoWeekday(date: Date): number {
  return date.getDay() || 7
}
